import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useIntl } from 'react-intl';
import styles from './DotsMenu.mod.scss';
import WifiOffIcon from '@assets/icons/wifiOff';
import TrashWhite from '@assets/icons/trashWhite';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import EyeIcon from '@assets/icons/eyeIcon';


const DotsMenu = ({ open, anchorRef, onDelete, onHide, onShow, isHidden, onClose, className, sampleCount, imageUrl, isCreabots, darktheme }) => {
  const intl = useIntl();
  const menuRef = useRef(null);
  const confirmModalRef = useRef(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  useEffect(() => {
    if (!open) setConfirmOpen(false);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      const isInMenu = menuRef.current && menuRef.current.contains(e.target);
      const isInAnchor = anchorRef?.current && anchorRef.current.contains(e.target);
      const isInConfirmModal = confirmModalRef.current && confirmModalRef.current.contains(e.target);
      if (!isInMenu && !isInAnchor && !isInConfirmModal) {
        onClose();
      }
      if (isInAnchor) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open, onClose, anchorRef]);

  if (!open) return null;
  let style = { position: 'fixed', zIndex: 2147483647 };
  if (anchorRef?.current) {
    const btnRect = anchorRef.current.getBoundingClientRect();
    let menuWidth = 200;
    let left = btnRect.left + btnRect.width / 2 - menuWidth / 2;
    if (left < 0) left = 0;
    if (left + menuWidth > window.innerWidth) left = window.innerWidth - menuWidth;
    style = {
      position: 'fixed',
      top: btnRect.bottom + 8,
      left,
      zIndex: 2147483647,
      display: confirmOpen ? 'none' : 'block'
    };
  }
  const menu = (
    <div className={`${(!isCreabots && !darktheme) ? 'theme-aula' : ''} ${styles.menu}`} style={style} ref={menuRef}>
      {isHidden ? (
        <button className={styles.menuItem} onClick={() => { onShow && onShow(); onClose(); }}>
          <EyeIcon style={{ width: 22, height: 19, marginRight: 10, flexShrink: 0 }} className={styles.iconMenu}/* color='var(--color-placeholder)' */ />
          {intl.formatMessage({ id: 'machineLearning.dotsMenu.activateClass' })}
        </button>
      ) : (
        <button className={styles.menuItem + ' ' + styles.hide} onClick={() => { onHide(); onClose(); }}>
          <WifiOffIcon style={{ width: 22, height: 19, marginRight: 8, flexShrink: 0 }} className={styles.iconMenu}/* color='var(--color-placeholder)' *//>
          {intl.formatMessage({ id: 'machineLearning.dotsMenu.deactivateClass' })}
        </button>
      )}
      <button className={styles.menuItem + ' ' + styles.delete} onClick={() => setConfirmOpen(true)}>
        <TrashWhite style={{ width: 16, height: 18, marginRight: 8, flexShrink: 0 }} />
        {intl.formatMessage({ id: 'machineLearning.dotsMenu.delete' })}
      </button>
    </div>
  );
  return <>
    {createPortal(menu, document.body)}
    {confirmOpen && createPortal(
      <ConfirmDeleteModal
        open={confirmOpen}
        onCancel={() => { setConfirmOpen(false); onClose(); }}
        onConfirm={() => {
          console.log('[DotsMenu] onConfirm clicked, onDelete:', !!onDelete);
          onDelete(); setConfirmOpen(false); onClose();
        }}
        className={className}
        sampleCount={sampleCount}
        imageUrl={imageUrl}
        ref={confirmModalRef}
        isCreabots={isCreabots}
        darktheme={darktheme}
      />,
      document.body
    )}
  </>;
};

export default DotsMenu;
